export const UI_SHOW_CHAT = 'IM/SHOW_CHAT';
export const UI_CLOSE_CHAT = 'IM/CLOSE_CHAT';
export const UI_TOGGLE_IM = 'IM/TOGGLE_IM';
export const UI_SCROLL_DOWN_CHAT_LIST = 'IM/SCROLL_DOWN_CHAT_LIST';
export const DATA_UPDATE_CUSTOMER_SERVICE_ACCOUNT = 'IM/UPDATE_CUSTOMER_SERVICE_ACCOUNT';
export const UI_SHOW_DIALOG = 'IM/SHOW_DIALOG';
export const UI_IMG_URL = 'IM/UI_IMG_URL';
export const DATA_IS_LOCAL_SESSION = 'IM/DATA_IS_LOCAL_SESSION';
export const IM_INITIALIZE_SDK = 'IM-VUE/initialize_SDK';
